import { axiosInstance } from "../../../js/api/axios";

export const likeCollectionById = async (collectionId) => {
  const response = await axiosInstance.post(
    "/umbraco/api/colourCollections/likeCollection?collectionId=" + collectionId
  );
  return response.data;
};

export const removeLikeCollectionById = async (collectionId) => {
  const response = await axiosInstance.delete(
    "/umbraco/api/colourCollections/removeCollectionLike?collectionId=" +
      collectionId
  );
  return response.data;
};
